import { getDefaultLocale } from "../envService";

// Default locale, now loaded from environment variable FRONTEND_DEFAULT_LOCALE (base64-encoded in env.js)
export const DEFAULT_LOCALE = getDefaultLocale();

export enum Locale {
  EN_GB = "en-GB",
  EN_US = "en-US",
  ES_ES = "es-ES",
  ES_AR = "es-AR",
}

export const LocalesLabels = {
  [Locale.EN_GB]: "English (UK)",
  [Locale.EN_US]: "English (US)",
  [Locale.ES_ES]: "Español (España)",
  [Locale.ES_AR]: "Español (Argentina)",
} as const;

export const SupportedLocales: Locale[] = [Locale.EN_GB, Locale.EN_US, Locale.ES_ES, Locale.ES_AR];
export const FALL_BACK_LOCALE = Locale.EN_GB;

/**
 * Validates and safely converts a string to a supported Locale.
 * If the locale is not supported, falls back to FALL_BACK_LOCALE and logs a warning.
 *
 * @param locale - The locale string to validate (typically from i18n.language)
 * @returns A valid Locale enum value
 */
export function validateLocale(locale: string): Locale {
  const localeValue = locale as Locale;
  if (SupportedLocales.includes(localeValue)) {
    return localeValue;
  }
  console.warn(`[validateLocale] Invalid locale: ${locale}, falling back to ${FALL_BACK_LOCALE}`);
  return FALL_BACK_LOCALE;
}
